import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useNotifications = () => useQuery({
  queryKey: ["notifications"], queryFn: () => api.get("/notifications").then((r) => r.data),
  refetchInterval: 60_000, refetchOnWindowFocus: true,
});

export const useReadNotification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.post(id ? `/notifications/${id}/read` : "/notifications/read-all"),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["notifications"] }),
  });
};
